module.exports = {
  __depends__: [
    require(53)
  ],
  bpmnImporter: [ 'type', require(7) ]
};